
export class RegisteredProjectNumber {
  constructor(
    public code: string
  ) { }

  get filterableData() {
    return `${ this.code }`.toLowerCase();
  }

  get name() {
    return this.code;
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/registered-project-number.ts